import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import React from "react";
import ReactDOM from "react-dom/client";

import { AppRouter } from "modules/routing/appRouter";
import { FFlagProvider } from "services/Flags";
import "./index.css";
import { initializeDayjsPlugins } from "utils/dayjsUtils";

import reportWebVitals from "./reportWebVitals";

if (import.meta.env.REACT_APP_DD_ENV) {
  datadogRum.init({
    applicationId: "dfe22215-963f-4e3e-95a0-dca35c91283c",
    clientToken: "pubd1728bd8bc02b6ea16033ce9aee7942e",
    service: "patient-web",
    site: "datadoghq.com",
    env: import.meta.env.REACT_APP_DD_ENV,
    version: import.meta.env.REACT_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 40,
    allowedTracingUrls: [location.origin],
    sessionPersistence: "local-storage",
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
  });
  datadogLogs.init({
    clientToken: "pubd1728bd8bc02b6ea16033ce9aee7942e",
    service: "patient-web",
    site: "datadoghq.com",
    env: import.meta.env.REACT_APP_DD_ENV,
    version: import.meta.env.REACT_APP_VERSION,
    sessionSampleRate: 100,
    sessionPersistence: "local-storage",
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
  });

  datadogRum.setGlobalContextProperty("origin", location.origin);
  datadogLogs.setGlobalContextProperty("origin", location.origin);
}

initializeDayjsPlugins();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <FFlagProvider>
      <AppRouter />
    </FFlagProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
